export const WORKFLOW_SIGNED_UP = new RegExp("\/loans\/manage\/applications")
export const START_NEW = new RegExp("\/startnew")